<template>
    <div class="full-width" v-loading="loading">
        <el-scrollbar>
            <div v-if="viewTag == 'list'">
                <div class="operation-box">
                    <el-button @click="viewTag = 'add'" tkey="添加">{{i18n.tkey("lang_add")}}</el-button>
                </div>

                <div v-if="null != record5List && record5List.length > 0">
                    <record5Info v-for="(v, i) in record5List" :key="v.id" :recordObj="v" @clickEdit="goEdit" @clickDelete="deleteRecord" />
                </div>

                <div v-show="null == record5List || record5List.length == 0">
                    <el-empty :description="i18n.tkey('lang_temporary_no_data')">
                        <el-button type="primary" @click="viewTag = 'add'" tkey="添加">{{i18n.tkey("lang_add")}}</el-button>
                    </el-empty>
                </div>
            </div>

            <div v-if="viewTag != 'list'">
                <div style="text-align: left; margin-top: 10px; margin-bottom: 10px">
                    <el-button @click="completeOperation" tkey="返回">{{i18n.tkey("lang_return")}}</el-button>
                </div>


                <addOrEditRecord5 :editObj="editObj" @editComplete="completeOperation" @addComplete="completeOperation" />
            </div>

        </el-scrollbar>
    </div>
</template>

<script setup>
    //響應機制的userinfo
    import {toRef, ref, onMounted, inject} from "vue";
    import {useUserinfo} from "@/stores/userinfo";
    import record5Api from "@/request/record5Api";
    import myUtil from "@/util/util";
    import record5Info from "@/components/shopopee/record5/record5Info"
    import addOrEditRecord5 from "@/components/shopopee/record5/addOrEditRecord5"

    const i18n = inject("i18n")

    const currCard = ref(null)
    const record5List = ref([])
    const userInfoRef = toRef(useUserinfo())

    const loading = ref(false)
    const editObj = ref(null)

    const viewTag = ref("list")

    function getRecordList() {
        loading.value = true
        const request = record5Api.queryMemberWorkAndRecord
        const params = request.getParams()

        params.companycode = userInfoRef.value.companycode

        request.send(params, fillRecordInfo)

    }

    function fillRecordInfo(res) {
        loading.value = false
        if (res.code == 200){
            const obj = res.detail
            record5List.value = obj.additionalrecord5FileModelList
            delete obj.additionalrecord5FileModelList
            currCard.value = obj
        }else{
            myUtil.alertError(res.msg)
        }
    }

    function goEdit(obj){
        viewTag.value = "edit"
        editObj.value = obj
    }

    function deleteRecord(obj){
        myUtil.confirmWarning(i18n.tkey("lang_delete_confirm"), () => {
            const request = record5Api.deleteRecord
            const params = request.getParams()

            params.id = obj.id

            request.send(params, (res) => {
                if (res.code == 200){
                    myUtil.alertSuccess(i18n.tkey("lang_delete_success"))

                    for (let i=0; i<record5List.value.length; i++){
                        const temp = record5List.value[i]

                        if (temp.id == obj.id){
                            record5List.value.splice(i, 1)
                            break
                        }
                    }

                }else{
                    myUtil.alertError(res.msg)
                }
            })
        })
    }

    function completeOperation(){
        editObj.value = null
        viewTag.value = "list"

        getRecordList()
    }

    onMounted(() => {
        getRecordList()
    })

</script>

<style scoped>
    .full-width {
        width: 100%;
        box-sizing: border-box;
        padding-left: 2px;
        padding-right: 2px;
        height: 100%;
        overflow-y: auto;
    }

    .operation-box {
        text-align: right;
        padding-right: 5px;
        margin-top: 5px;
        margin-bottom: 10px;
    }
</style>